<div class="cockpit-card-container" cdkDropList (cdkDropListDropped)="onDropCard($event)" *ngIf="cockpitCards && cockpitCards.length > 0">
	<div class="chart" cdkDrag [ngClass]="chart.type" *ngFor="let chart of cockpitCards; let index = index">
		<div class="header" cdkDragHandle>
			<span class="title">{{ labels[chart.title_label] ? labels[chart.title_label] : chart.title }}</span>
			<div class="button-container">
				<span
					class="icon-button arrow-btn"
					(click)="moveCardUp(index); $event.stopPropagation()"
					[ngClass]="{ disabled: index === 0 }"
					title="Mover para cima"
					><fa-icon [icon]="icons.faArrowUp"></fa-icon
				></span>
				<span
					class="icon-button arrow-btn"
					(click)="moveCardDown(index); $event.stopPropagation()"
					[ngClass]="{ disabled: index === cockpitCards.length - 1 }"
					title="Mover para baixo"
					><fa-icon [icon]="icons.faArrowDown"></fa-icon
				></span>
				<span class="icon-button" (click)="goToChartReport(chart.id)" *ngIf="chart.availableReports"
					><fa-icon [icon]="icons.faExternalLink"></fa-icon
				></span>
				<span class="icon-button" (click)="deleteChart(chart, index)" *ngIf="!config.hideDelete"
					><fa-icon [icon]="icons.faTimes"></fa-icon
				></span>
			</div>
		</div>
		<div>
			<span>{{ chart.chartData ? chart.chartData : 0 }}</span>
		</div>
	</div>
</div>

<div
	class="cockpit-chart-container"
	cdkDropList
	(cdkDropListDropped)="onDropChart($event)"
	*ngIf="cockpitCharts && cockpitCharts.length > 0">
	<div
		class="chart"
		cdkDrag
		[ngStyle]="{ 'grid-column': 'span ' + getChartSize(chart) }"
		[ngClass]="[chart.type, chart.availableDrillDown ? 'clickable' : '']"
		*ngFor="let chart of cockpitCharts; let index = index">
		<div class="header" cdkDragHandle>
			<span class="title">{{ labels[chart.title_label] ? labels[chart.title_label] : chart.title }}</span>
			<div class="button-container">
				<span
					class="icon-button arrow-btn"
					(click)="moveChartUp(index); $event.stopPropagation()"
					[ngClass]="{ disabled: index === 0 }"
					title="Mover para cima"
					><fa-icon [icon]="icons.faArrowUp"></fa-icon
				></span>
				<span
					class="icon-button arrow-btn"
					(click)="moveChartDown(index); $event.stopPropagation()"
					[ngClass]="{ disabled: index === cockpitCharts.length - 1 }"
					title="Mover para baixo"
					><fa-icon [icon]="icons.faArrowDown"></fa-icon
				></span>
				<span
					class="icon-button"
					*ngIf="getChartSize(chart) === 2 && !config.hideResize"
					(click)="setChartSize(chart, 1)"
					title="Reduzir tamanho"
					><fa-icon [icon]="icons.faCircleMinus"></fa-icon
				></span>
				<span
					class="icon-button"
					*ngIf="getChartSize(chart) === 1 && !config.hideResize"
					(click)="setChartSize(chart, 2)"
					title="Aumentar tamanho"
					><fa-icon [icon]="icons.faCirclePlus"></fa-icon
				></span>
				<span class="icon-button" (click)="goToChartReport(chart)" *ngIf="chart.availableReports" title="Exportar Relatório"
					><fa-icon [icon]="icons.faExternalLink"></fa-icon
				></span>
				<span
					class="icon-button rotatable"
					*ngIf="chart.type === 'bar'"
					[ngClass]="{ 'rotate-90': getChartIndexAxis(chart) === 'y' }"
					(click)="setChartIndexAxis(chart, getChartIndexAxis(chart) === 'x' ? 'y' : 'x'); updateChart()"
					title="Rotacionar Gráfico"
					><fa-icon [icon]="icons.faChartSimple"></fa-icon
				></span>
				<span class="icon-button" (click)="deleteChart(chart, index)" *ngIf="!config.hideDelete" title="Excluir Relatório"
					><fa-icon [icon]="icons.faTimes"></fa-icon
				></span>
			</div>
		</div>
		<ng-container *ngIf="chart.chartData.datasets[0].data.length > 0">
			<ng-container *ngIf="chart.type === 'bar'">
				<canvas
					baseChart
					[data]="chart.chartData"
					[type]="chart.type"
					[options]="getChartOptions(chart)"
					[legend]="false"
					(mouseenter)="indexChartHover = index"
					(chartClick)="onBarChartClick($event, index)">
				</canvas>
			</ng-container>

			<ng-container *ngIf="chart.type === 'pie'">
				<canvas
					baseChart
					[data]="chart.chartData"
					[type]="chart.type"
					[options]="getChartOptions(chart)"
					(mouseenter)="indexChartHover = index">
				</canvas>
			</ng-container>

			<ng-container *ngIf="chart.type === 'gauge'">
				<canvas
					baseChart
					[data]="chart.chartData"
					[type]="'doughnut'"
					[options]="getChartOptions(chart)"
					(mouseenter)="indexChartHover = index">
				</canvas>
			</ng-container>

			<ng-container *ngIf="chart.type === 'line'">
				<canvas
					baseChart
					[data]="chart.chartData"
					[type]="'line'"
					[legend]="chart.multiple ? true : false"
					[options]="getChartOptions(chart)"
					(mouseenter)="indexChartHover = index">
				</canvas>
			</ng-container>
			<!-- Tirei os (chartClick)="chartSelect($event)" temporariamente porque não estamos utilizando eles, está com bug -->
		</ng-container>

		<ng-container *ngIf="chart.chartData.datasets[0].data.length === 0">
			<div class="empty-data">
				<span>{{ labels.lbl_indicador_sem_dado_periodo_selecionado }}</span>
				<span><fa-icon [icon]="icons.faFolderOpen"></fa-icon></span>
			</div>
		</ng-container>
	</div>
</div>
